'use es6';

import store from 'AdsUI/redux-store';
import { getScopes } from 'AdsUI/selectors/AuthSelectors';
export const Scopes = {
  ADS_PRO: 'ads-pro',
  ADS_WRITE: 'ads-write',
  ADS_TRUSTED: 'ads-trusted',
  ADS_READ: 'ads-read',
  ADS_DEMO_ACCESS: 'ads-demo-access',
  ADS_OFFLINE_EVENTS: 'ads-offline-events',
  ADS_GOALS_ACCESS: 'goals-ads-access',
  MULTI_ATTRIBUTION: 'ads-multi-attribution',
  ADV_AUDIENCES: 'ads-adv-web-audiences',
  ADV_REPORTING: 'ads-roi-reporting',
  WORKFLOWS: 'workflows-app-access',
  SITEPAGES_ACCESS: 'sitepages-access',
  BLOG_ACCESS: 'blog-access',
  LANDING_PAGE_ACCESS: 'landingpages-access',
  WORKFLOWS_EDIT: 'workflows-edit-team-owned',
  CONTENT_TEAM_ASSIGNMENT: 'content-team-assignment',
  LISTS_ACCESS: 'lists-access',
  CONTACTS_LISTS_ACCESS: 'contacts-lists-access',
  ILS_LISTS_ACCESS: 'ils-lists-read',
  CONTACTS_LISTS_CREATE_SIMPLE: 'contacts-lists-create-simple',
  CONTACTS_LISTS_CREATE_ADVANCED: 'contacts-lists-create-advanced',
  ILS_LISTS_WRITE: 'ils-lists-write',
  MARKETABLE_CONTACTS_ACCESS: 'marketable-contacts-access',
  MARKETABLE_CONTACTS_WRITE: 'marketable-contacts-write',
  // Any action that might create a marketable contact should check this gate
  SMART_CONTENT: 'smartcontent',
  TEAMS_ADVANCED_MODELING_ACCESS: 'teams-advanced-modeling-access'
}; // HACK: When someone is in BIGLYTICS, everyone should be treated as a DEMO user.

const checkScopeAndBiglyticsOverride = scope => getScopes(store.getState()).indexOf(scope) !== -1; // Takes array of strings or a single string. Returns true if
// any one of the scopes is available.


export const hasScope = function hasScope(scope) {
  if (scope instanceof Array) {
    return scope.some(s => {
      return checkScopeAndBiglyticsOverride(s);
    });
  } else {
    return checkScopeAndBiglyticsOverride(scope);
  }
};
export const hasWriteScope = () => {
  return hasScope(Scopes.ADS_WRITE);
};
export const hasDemoScope = () => {
  return hasScope(Scopes.ADS_DEMO_ACCESS);
};
export const hasReadScope = () => {
  return hasScope(Scopes.ADS_READ);
};
export const hasRoiReportingScope = () => hasScope(Scopes.ADV_REPORTING);